<div class="shop-add component-container component-page-container action-button-wrapper"
     fxLayout="column"
     fxLayoutGap="2%"
>
    <div class="sh-page-wrapper bottom-action-mg">
        <div fxFlex="100%">
            <custom-panel header="Regał" [areButtons]="false" class="flex flex-grow">
                <div panel-body>
                    <form [formGroup]="creatingForm" (ngSubmit)="onSubmit()" fxLayout="column">
                        <mat-form-field>
                            <input matInput placeholder="Nazwa" formControlName="Name" required>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput type="number" placeholder="Metry" formControlName="Meters" required>
                        </mat-form-field>

                        <button #submitButton type="submit" style="display: none;"></button>
                    </form>
                </div>
            </custom-panel>
        </div>
    </div>

</div>


<div class="action-buttons">
    <div class="action-buttons-inner pv-xxxs" fxLayout="row"
         fxLayoutGap="1%" fxLayoutAlign="flex-end center"
    >
        <button-spinner class="ml-xxs" [inProgress]="isSaving" diameter="20">
        </button-spinner>
        <button type="button" class="upper action-button butt-back action-button-icon"
                (click)="navigationBack()"
        >
            <p class="upper">wróć</p>
            <mat-icon class="action-icon">keyboard_return</mat-icon>
        </button>
        <button (click)="submitButton.click()"
                [disabled]="isSaving" class="upper action-button butt-primary action-button-icon">
            <p class="upper">zapisz</p>
            <mat-icon class="action-icon">save_alt</mat-icon>
        </button>
    </div>
</div>
